// =============================================================
// PinScreen — full-screen PIN unlock that mirrors the original
// inline #pin-screen div.
// =============================================================

import { useEffect, useRef, useState } from 'react'
import { submitPin } from '../lib/auth'

interface PinScreenProps {
  /** Called once a successful auth unlock happens. */
  onUnlocked: () => void
}

export function PinScreen({ onUnlocked }: PinScreenProps) {
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    const id = window.setTimeout(() => inputRef.current?.focus(), 100)
    return () => window.clearTimeout(id)
  }, [])

  async function handleSubmit() {
    if (!pin.trim() || submitting) return
    setSubmitting(true)
    setError('')
    try {
      const ok = await submitPin(pin.trim())
      if (ok) {
        onUnlocked()
        return
      }
      setError('PIN 不对哦～')
      setPin('')
      // Mirror original: red border for 1.5s
      if (inputRef.current) {
        inputRef.current.style.borderColor = '#EF4444'
        window.setTimeout(() => {
          if (inputRef.current) inputRef.current.style.borderColor = ''
        }, 1500)
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'var(--ivory-light)',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <img
        src="/apple-touch-icon.png"
        alt=""
        style={{ width: 80, height: 80, borderRadius: 20 }}
      />
      <div style={{ fontSize: 15, color: 'var(--cloud-dark)' }}>琥珀 🔒</div>
      <input
        ref={inputRef}
        type="password"
        inputMode="text"
        autoComplete="off"
        placeholder="PIN"
        value={pin}
        onChange={(e) => setPin(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handleSubmit()
        }}
        style={{
          width: 200,
          padding: '12px 16px',
          border: '2px solid var(--ivory-dark)',
          borderRadius: 12,
          fontSize: 18,
          textAlign: 'center',
          background: 'white',
          color: '#191919',
          outline: 'none',
        }}
      />
      <button
        type="button"
        onClick={handleSubmit}
        disabled={submitting}
        style={{
          width: 200,
          padding: '10px 16px',
          border: 'none',
          borderRadius: 12,
          background: '#D97706',
          color: 'white',
          fontSize: 16,
          fontWeight: 600,
          cursor: 'pointer',
          opacity: submitting ? 0.7 : 1,
        }}
      >
        {submitting ? '...' : '进入'}
      </button>
      <div style={{ color: '#EF4444', fontSize: 13, minHeight: 20 }}>{error}</div>
    </div>
  )
}